import React from 'react';
import InitialScreen from './screens/InitialScreen';
import '../App.css';
import ApplicationScreen from './screens/application/ApplyScreen';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import SignupScreen from './screens/account/SignupScreen';
import SigninScreen from './screens/account/SigninScreen';
import CompletedScreen from './screens/account/CompletedScreen';
import ValidationScreen from './container/validation-screen';

import { Path } from './constants/path';
import { connect } from 'react-redux';
import { AppState } from './store';
import OrderCompleteScreen from './screens/application/ApplyCompleteScreen';
import ApplyConfirmScreen from './screens/application/ApplyConfirmScreen';
import NotFoundTemplate from './screens/others/NotFound';
import RedirectWithDecodeURL from './screens/RedirectWithDecodeURL';
import Identification from './screens/identification/Identification';
import { AccountStepGuard } from './components/AccountStepGuard';
import { IdentificationGuard } from './components/IdentificationGuard';
import { ContractorElectricGuard } from './components/ContractorElectricGuard';

const mapStateToProps = (state: AppState) => {
  return {
    index: state.index,
    property: state.property,
    signUpForm: state.signUpForm,
    signInForm: state.signInForm,
    applyForm: state.applyForm,
    validation: state.validation,
    user: state.user
  };
};

type Props = ReturnType<typeof mapStateToProps>;

const V2App: React.FC<Props> = props => {
  return (
    <div>
      <Router>
        <ContractorElectricGuard>
          <Switch>
            <Route path={Path.redirect} component={RedirectWithDecodeURL} />
            <Route
              path={Path.identification}
              render={() => (
                <IdentificationGuard>
                  <Identification />
                </IdentificationGuard>
              )}
            />
            <Route exact path={Path.home} component={InitialScreen} />
            <Route
              exact
              path={Path.account.signup}
              render={() => (
                <AccountStepGuard>
                  <SignupScreen hasElectricContract={props.property.property.hasElectricContract} />
                </AccountStepGuard>
              )}
            />
            <Route
              exact
              path={Path.account.signin}
              render={() => (
                <AccountStepGuard>
                  <SigninScreen hasElectricContract={props.property.property.hasElectricContract} />
                </AccountStepGuard>
              )}
            />
            <Route
              exact
              path={Path.account.validation}
              render={() => (
                <AccountStepGuard>
                  <ValidationScreen />
                </AccountStepGuard>
              )}
            />
            <Route
              exact
              path={Path.account.completed}
              render={() => (
                <AccountStepGuard>
                  <CompletedScreen hasElectricContract={props.property.property.hasElectricContract} />
                </AccountStepGuard>
              )}
            />
            <Route
              exact
              path={Path.application.url}
              render={() => <ApplicationScreen hasElectricContract={props.property.property.hasElectricContract} />}
            />
            <Route
              exact
              path={Path.application.confirm}
              render={() => <ApplyConfirmScreen hasElectricContract={props.property.property.hasElectricContract} />}
            />
            <Route
              exact
              path={Path.application.complete}
              render={() => (
                <OrderCompleteScreen
                  hasElectricContract={props.property.property.hasElectricContract}
                  sumamoruInstallAppTypes={props.property.property.sumamoruInstallAppTypes}
                  applicantType={props.property.property.applicantType}
                />
              )}
            />
            <Route component={NotFoundTemplate} />
          </Switch>
        </ContractorElectricGuard>
      </Router>
    </div>
  );
};
export default connect(mapStateToProps, {})(V2App);
